<template>
  <v-card
    class="d-flex justify-space-between py-2 elevation-2"
    :class="[
      this.$vuetify.breakpoint.mobile ? 'flex-column' : 'align-center',
      this.marginBottom ? 'mb-14' : 'mb-5',
    ]"
    :style="{
      'border-radius': '10px',
      background: $vuetify.theme.dark ? '#252525' : '',
      height:
        $vuetify.breakpoint.mobile && !amounts
          ? '190px'
          : $vuetify.breakpoint.mobile && amounts
          ? '130px'
          : '100px',
    }"
  >
    <div class="d-flex" style="width: 210px;">
      <v-icon class="mx-4" x-large :color="iconsData(type[0]).color">
        {{ iconsData(type[0]).name }}
      </v-icon>
      <div>
        <div class="font-weight-medium" style="font-size: 18px;">
          <span v-if="amounts">
            {{ amounts[0] }}
          </span>
          <span v-else :class="getColor(values[0])">
            {{ getPortugueseMoney(values[0]) }}
          </span>
        </div>
        <div style="font-size: 14px;">
          {{ iconsData(type[0]).legend }}
        </div>
      </div>
    </div>
    <div class="d-flex" style="width: 210px;">
      <v-icon class="mx-4" x-large :color="iconsData(type[1]).color">
        {{ iconsData(type[1]).name }}
      </v-icon>
      <div>
        <div class="font-weight-medium" style="font-size: 18px;">
          <span v-if="amounts">
            {{ amounts[1] }}
          </span>
          <span v-else :class="getColor(values[1])">
            {{ getPortugueseMoney(values[1]) }}
          </span>
        </div>
        <div style="font-size: 14px;">
          {{ iconsData(type[1]).legend }}
        </div>
      </div>
    </div>
    <div
      :class="this.$vuetify.breakpoint.mobile && 'ml-4'"
      :style="{
        display: $vuetify.breakpoint.mobile && !values ? 'none' : '',
        width: '190px',
      }"
    >
      <div
        v-if="!amounts"
        class="font-weight-medium"
        :class="getColor(values[0] - Math.abs(values[1]))"
        style="font-size: 18px;"
      >
        {{ getPortugueseMoney(values[0] - Math.abs(values[1])) }}
      </div>
      <div v-if="!amounts" style="font-size: 14px;">
        {{ $t("total") }}
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "AnalyticalReportCard",
  props: ["type", "values", "amounts", "marginBottom"],
  methods: {
    iconsData(type) {
      switch (type) {
        case "depositQty": //Quantidade de depósitos
          return {
            color: "#8EC000",
            name: "mdi-credit-card-outline",
            legend: this.$t("amountOfDeposits"),
          };
        case "deposit": //Valor dos depósitos
          return {
            color: "#8EC000",
            name: "mdi-credit-card-outline",
            legend: this.$t("deposits"),
          };
        case "withdrawQty": //Quantidade de saques
          return {
            color: "#00B828",
            name: "mdi-cash-multiple",
            legend: this.$t("amountOfWithdrawals"),
          };
        case "withdraw": //Valor dos saques
          return {
            color: "#00B828",
            name: "mdi-cash-multiple",
            legend: this.$t("withdrawals"),
          };
        case "betsQty": //Quantidade de apostas em esportes
          return {
            color: "#E85300",
            name: "mdi-ticket-confirmation",
            legend: this.$t("betsAmount"),
          };
        case "bets": //Valor das apostas em esportes
          return {
            color: "#E85300",
            name: "mdi-ticket-confirmation",
            legend: this.$t("bets"),
          };
        case "betsPrizeQty": //Quantidade de prêmios em esportes
          return {
            color: "#FFE600",
            name: "mdi-trophy-award",
            legend: this.$t("betsPrizeQty"),
          };
        case "betsPrize": //Valor de prêmios em esportes
          return {
            color: "#FFE600",
            name: "mdi-trophy-award",
            legend: this.$t("prizeValue"),
          };
        case "betCasinoQty": //Quantidade de apostas no cassino
          return {
            color: "#F000000",
            name: "mdi-cards-playing",
            legend: this.$t("betCasinoQty"),
          };
        case "betCasino": //Valor de apostas em cassino
          return {
            color: "#F000000",
            name: "mdi-cards-playing",
            legend: this.$t("betCasino"),
          };
        case "prizesCasinoQty": //Quantidade de prêmios no cassino
          return {
            color: "#FFE600",
            name: "mdi-poker-chip",
            legend: this.$t("prizeCasinoQty"),
          };
        case "prizesCasino": //Valor de prêmios no cassino
          return {
            color: "#FFE600",
            name: "mdi-poker-chip",
            legend: this.$t("prizesCasino"),
          };
        default:
          return {
            color: "",
            name: "",
            legend: "",
          };
      }
    },
    getPortugueseMoney(value) {
      return Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getColor(value) {
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
  },
};
</script>
